/* =========================================================
   __                 ____  _
  |   \  ___  __ __  |  _ || |  _ _   ___
  | |) |/ -_) \ V /  |  __|| | | | | / -_)
  |___/ \___|  \_/   |_|   |_| \_,_| \___| o o o

========================================================= */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Avatar from "@mui/material/Avatar";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDInput from "components/MDInput";
import TableHeader from "components/Table/TableHeader";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Navbar from "examples/Navbars/NavBar";
import Footer from "examples/Footer";
import { useTranslation } from "react-i18next";
import { APP_STATE } from "services/Define";
import { FetchData } from "services/Request";
import { useSelector } from "react-redux";
import * as Func from "services/Function";
import ProductClip from "./ProductClip";

const initAttr = {
  code: "",
  id: "",
  name_th: "",
  detail_th: "",
  name_bill: "",
  amount: "",
  vat: "",
  price: "",
  enable: "Y",
  date_create: "",
  date_update: "",
};

const initFind = {
  search: "",
  order_by: "tb.code",
  order_sort: "desc",
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

const initZoom = {
  title: "🔴 เรียนสด {system} ผ่านโปรแกรม Zoom",
  date_live: Func.dateNow(),
  time_start: "20:00:00",
  time_stop: "22:00:00",
  meeting_id: "",
  passcode: "",
  link: "",
};

const initLine = {
  title: "🔴 เรียนสด {system} ผ่าน Line meeting",
  date_live: Func.dateNow(),
  time_start: "20:00:00",
  time_stop: "22:00:00",
  link: "",
};

function Product() {
  const mod = "product";
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [zoom, setZoom] = useState(initZoom);
  const [line, setLine] = useState(initLine);
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalMessage, setModalMessage] = useState(false);
  const [modalZoom, setModalZoom] = useState(false);
  const [modalLine, setModalLine] = useState(false);
  const [msg, setMsg] = useState("");
  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: "tb.filepic", label: t(`attr.image`), align: "center" },
    { id: "tb.code", label: t(`attr.code`), align: "center" },
    { id: "tb.id", label: t(`attr.id`), align: "center" },
    { id: "tb.name_th", label: t(`attr.name`), align: "left" },
    { id: "tb.detail_th", label: t(`attr.detail`), align: "left" },
    { id: "tb.name_bill", label: "ชื่อบิล", align: "left" },
    { id: "tb.price", label: t(`attr.price`), align: "right" },
    { id: "tb.vat", label: "Vat", align: "right" },
    { id: "tb.amount", label: "รวม", align: "right" },
    { id: "tb.enable", label: t(`attr.enable`), align: "center" },
    { id: "edit", label: "", align: "center", sort: false },
    { id: "line", label: "", align: "center", sort: false },
    { id: "zoom", label: "", align: "center", sort: false },
    { id: "msg", label: "", align: "center", sort: false },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon="notifications"
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData("POST", `/app/req/${mod}-view`, app.token, {
      lang: app.lang,
      token: app.token,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      sort: data.order_sort,
    }).then((result) => {
      if (result.status === "OK") {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const open = (item) => {
    setLoading(true);
    setAttr(initAttr);

    FetchData("POST", `/app/req/${mod}-open`, app.token, {
      token: app.token,
      lang: app.lang,
      code: item.code,
    }).then((result) => {
      if (result.status === "OK") {
        setAttr(result.data);
        setModalEdit(true);

        setLoading(false);
      }
    });
  };

  const add = () => {
    Swal.fire({
      title: t(`alert.confirm_add_title`),
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: "#dc3545",
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);
        FetchData("POST", `/app/req/${mod}-add`, app.token, {
          token: app.token,
          lang: app.lang,
          data: {
            id: attr.id,
            name_th: attr.name_th,
            detail_th: attr.detail_th,
            name_bill: attr.name_bill,
            amount: attr.amount,
            vat: attr.vat,
            price: attr.price,
            enable: attr.enable,
          },
        }).then((result) => {
          setLoading(false);

          if (result.status === "OK") {
            view(find);
            setModalAdd(false);
            showNotify(t(`alert.addcomplete`), "success");
          } else {
            showNotify(t(`alert.saveerror`), "error");
          }
        });
      }
    });
  };

  const edit = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: "#dc3545",
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData("POST", `/app/req/${mod}-edit`, app.token, {
          token: app.token,
          lang: app.lang,
          code: attr.code,
          data: {
            id: attr.id,
            name_th: attr.name_th,
            detail_th: attr.detail_th,
            name_bill: attr.name_bill,
            amount: attr.amount,
            vat: attr.vat,
            price: attr.price,
            enable: attr.enable,
          },
        }).then((result) => {
          setLoading(false);

          if (result.status === "OK") {
            view(find);
            setModalEdit(false);
            showNotify(t(`alert.editcomplete`), "success");
          } else {
            showNotify(t(`alert.saveerror`), "error");
          }
        });
      }
    });
  };

  const sendMessage = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: "#dc3545",
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData("POST", `/app/req/${mod}-sendmessage`, app.token, {
          token: app.token,
          lang: app.lang,
          code: attr.code,
          data: {
            msg: msg,
          },
        }).then((result) => {
          setLoading(false);

          if (result.status === "OK") {
            setMsg("");
            showNotify(t(`alert.editcomplete`), "success");
          } else {
            showNotify(t(`alert.saveerror`), "error");
          }
        });
      }
    });
  };

  const sendLine = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: "#dc3545",
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData("POST", `/app/req/${mod}-sendline`, app.token, {
          token: app.token,
          lang: app.lang,
          code: attr.code,
          data: {
            title: line.title,
            date_live: line.date_live,
            time_start: line.time_start,
            time_stop: line.time_stop,
            link: line.link,
          },
        }).then((result) => {
          setLoading(false);

          if (result.status === "OK") {
            showNotify(t(`alert.editcomplete`), "success");
          } else {
            showNotify(t(`alert.saveerror`), "error");
          }
        });
      }
    });
  };

  const sendZoom = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: "#dc3545",
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData("POST", `/app/req/${mod}-sendzoom`, app.token, {
          token: app.token,
          lang: app.lang,
          code: attr.code,
          data: {
            title: zoom.title,
            date_live: zoom.date_live,
            time_start: zoom.time_start,
            time_stop: zoom.time_stop,
            meeting_id: zoom.meeting_id,
            passcode: zoom.passcode,
            link: zoom.link,
          },
        }).then((result) => {
          setLoading(false);

          if (result.status === "OK") {
            showNotify(t(`alert.editcomplete`), "success");
          } else {
            showNotify(t(`alert.saveerror`), "error");
          }
        });
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? "desc" : "asc" });
  };

  const init = () => {
    FetchData("POST", `/app/req/${mod}-init`, app.token, {
      token: app.token,
      lang: app.lang,
    }).then((result) => {
      if (result.status === "OK") {
        setAttr(initAttr);

        if (id === undefined) {
          view(find);
        } else {
          setLoading(false);
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const enableDisplay = (inp) => {
    if (inp === "Y") return <Icon color="info">verified</Icon>;
    return <Icon color="error">not_interested</Icon>;
  };

  const imageDisplay = (item) => {
    return <Avatar alt={item.name} src={item.image} variant="square" />;
  };

  const btnOpen = (item) => {
    return (
      <MDButton variant="text" color="info" size="small" href={`/${mod}/${item.code}`}>
        {item.id}
      </MDButton>
    );
  };

  const btnEdit = (item) => {
    return (
      <MDButton variant="text" color="success" size="small" onClick={() => open(item)}>
        <Icon>border_color</Icon> {t(`element.edit`)}
      </MDButton>
    );
  };

  const btnMessage = (item) => {
    return (
      <MDButton
        variant="text"
        color="info"
        size="small"
        onClick={() => {
          setAttr(item);
          setMsg("");
          setModalMessage(true);
        }}
      >
        <Icon>forward_to_inbox</Icon> ส่งข้อความ
      </MDButton>
    );
  };

  const btnZoom = (item) => {
    return (
      <MDButton
        variant="text"
        color="error"
        size="small"
        onClick={() => {
          setAttr(item);
          setZoom({ ...initZoom, title: initZoom.title.split("{system}").join(item.name_bill) });
          setModalZoom(true);
        }}
      >
        <Icon>forward_to_inbox</Icon> แจ้งห้อง Zoom
      </MDButton>
    );
  };

  const btnLine = (item) => {
    return (
      <MDButton
        variant="text"
        color="success"
        size="small"
        onClick={() => {
          setAttr(item);
          setLine({ ...initLine, title: initLine.title.split("{system}").join(item.name_bill) });
          setModalLine(true);
        }}
      >
        <Icon>forward_to_inbox</Icon> แจ้งห้อง Line
      </MDButton>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display="flex" justifyContent="space-between" alignItems="flex-start">
                <form
                  noValidate
                  onSubmit={(e) => {
                    e.preventDefault();
                    view({ ...find, page: 1 });
                  }}
                >
                  <MDInput
                    label={t(`element.search`)}
                    onChange={(e) => setFind({ ...find, search: e.target.value })}
                    value={find.search}
                    inputProps={{
                      form: {
                        autocomplete: "off",
                      },
                    }}
                  />
                </form>
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={() => {
                    setAttr(initAttr);
                    setModalAdd(true);
                  }}
                >
                  <Icon>add_circle_outline</Icon>&nbsp;{t(`element.add`)}
                </MDButton>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{imageDisplay(row)}</TableCell>
                      <TableCell align="center">{row.code}</TableCell>
                      <TableCell align="center">{btnOpen(row)}</TableCell>
                      <TableCell align="left">{row.name_th}</TableCell>
                      <TableCell align="left">{row.detail_th}</TableCell>
                      <TableCell align="left">{row.name_bill}</TableCell>
                      <TableCell align="right">{Func.numberDisplay(row.price)}</TableCell>
                      <TableCell align="right">{Func.numberDisplay(row.vat)}</TableCell>
                      <TableCell align="right">{Func.numberDisplay(row.amount)}</TableCell>
                      <TableCell align="center">{enableDisplay(row.enable)}</TableCell>
                      <TableCell align="center">{btnEdit(row)}</TableCell>
                      <TableCell align="center">{btnLine(row)}</TableCell>
                      <TableCell align="center">{btnZoom(row)}</TableCell>
                      <TableCell align="center">{btnMessage(row)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display="flex" justifyContent="space-between" alignItems="flex-start">
                <MDButton variant={show ? "contained" : "outlined"} color="dark" onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant="outlined"
                  color="secondary"
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderInfo = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MDInput
            label={t(`attr.id`)}
            onChange={(e) => setAttr({ ...attr, id: e.target.value })}
            value={attr.id}
            variant="standard"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label={t(`attr.name`)}
            onChange={(e) => setAttr({ ...attr, name_th: e.target.value })}
            value={attr.name_th}
            variant="standard"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label={t(`attr.detail`)}
            onChange={(e) => setAttr({ ...attr, detail_th: e.target.value })}
            value={attr.detail_th}
            variant="standard"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label="ชื่อบิล"
            onChange={(e) => setAttr({ ...attr, name_bill: e.target.value })}
            value={attr.name_bill}
            variant="standard"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label="ราคา"
            onChange={(e) => setAttr({ ...attr, price: e.target.value })}
            value={attr.price}
            variant="standard"
            fullWidth
            type="number"
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label="Vat"
            onChange={(e) => setAttr({ ...attr, vat: e.target.value })}
            value={attr.vat}
            variant="standard"
            fullWidth
            type="number"
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label="รวม"
            onChange={(e) => setAttr({ ...attr, amount: e.target.value })}
            value={attr.amount}
            variant="standard"
            fullWidth
            type="number"
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={attr.enable === "Y"}
                onChange={(e) => setAttr({ ...attr, enable: e.target.checked ? "Y" : "N" })}
                inputProps={{
                  "aria-label": "enable",
                }}
              />
            }
            label="Enable"
          />
        </Grid>
      </Grid>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog
        open={modalAdd}
        maxWidth="sm"
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label="close"
            onClick={() => setModalAdd(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="gradient" color="success" onClick={add}>
            <Icon>save</Icon>&nbsp;{t(`element.save`)}
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const renderEdit = () => {
    return (
      <Dialog
        open={modalEdit}
        maxWidth="sm"
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          {t(`element.edit`)}
          <IconButton
            aria-label="close"
            onClick={() => setModalEdit(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="gradient" color="success" onClick={edit}>
            <Icon>save</Icon>&nbsp;{t(`element.save`)}
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const renderMessage = () => {
    return (
      <Dialog
        open={modalMessage}
        maxWidth="lg"
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          ส่งข้อความ
          <IconButton
            aria-label="close"
            onClick={() => setModalMessage(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers style={{ minWidth: "600px" }}>
          <MDBox p={0}>
            <Grid container>
              <Grid item xs={12}>
                <MDInput
                  label="ข้อความ"
                  onChange={(e) => setMsg(e.target.value)}
                  value={msg}
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={15}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="gradient" color="primary" onClick={sendMessage}>
            <Icon>send</Icon>&nbsp;ส่ง
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const renderZoom = () => {
    return (
      <Dialog
        open={modalZoom}
        maxWidth="sm"
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          แจ้งห้อง Zoom
          <IconButton
            aria-label="close"
            onClick={() => setModalZoom(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label="หัวข้อ"
                  onChange={(e) => setZoom({ ...zoom, title: e.target.value })}
                  value={zoom.title}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="วันที่"
                  onChange={(e) => setZoom({ ...zoom, date_live: e.target.value })}
                  value={zoom.date_live}
                  variant="outlined"
                  fullWidth
                  type="date"
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="เวลาเริ่มสอน"
                  onChange={(e) => setZoom({ ...zoom, time_start: e.target.value })}
                  value={zoom.time_start}
                  variant="outlined"
                  fullWidth
                  type="time"
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="เวลาสอนเสร็จ"
                  onChange={(e) => setZoom({ ...zoom, time_stop: e.target.value })}
                  value={zoom.time_stop}
                  variant="outlined"
                  fullWidth
                  type="time"
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="Meeting ID"
                  onChange={(e) => setZoom({ ...zoom, meeting_id: e.target.value })}
                  value={zoom.meeting_id}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="Passcode"
                  onChange={(e) => setZoom({ ...zoom, passcode: e.target.value })}
                  value={zoom.passcode}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="Link"
                  onChange={(e) => setZoom({ ...zoom, link: e.target.value })}
                  value={zoom.link}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="gradient" color="primary" onClick={sendZoom}>
            <Icon>send</Icon>&nbsp;ส่ง
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const renderLine = () => {
    return (
      <Dialog
        open={modalLine}
        maxWidth="sm"
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          แจ้งห้อง Line
          <IconButton
            aria-label="close"
            onClick={() => setModalLine(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label="หัวข้อ"
                  onChange={(e) => setLine({ ...line, title: e.target.value })}
                  value={line.title}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="วันที่"
                  onChange={(e) => setLine({ ...line, date_live: e.target.value })}
                  value={line.date_live}
                  variant="outlined"
                  fullWidth
                  type="date"
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="เวลาเริ่มสอน"
                  onChange={(e) => setLine({ ...line, time_start: e.target.value })}
                  value={line.time_start}
                  variant="outlined"
                  fullWidth
                  type="time"
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="เวลาสอนเสร็จ"
                  onChange={(e) => setLine({ ...line, time_stop: e.target.value })}
                  value={line.time_stop}
                  variant="outlined"
                  fullWidth
                  type="time"
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label="Link"
                  onChange={(e) => setLine({ ...line, link: e.target.value })}
                  value={line.link}
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="gradient" color="primary" onClick={sendLine}>
            <Icon>send</Icon>&nbsp;ส่ง
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const renderInner = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display="flex" justifyContent="space-between" alignItems="flex-start">
                <MDButton variant="gradient" color="warning" href={`/${mod}`}>
                  <Icon>arrow_back</Icon>&nbsp;Back
                </MDButton>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <ProductClip />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderPage = () => {
    if (id === undefined) return renderList();
    return renderInner();
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.setting`), t(`menu.product`)]} />
      {renderPage()}
      {renderAdd()}
      {renderEdit()}
      {renderMessage()}
      {renderLine()}
      {renderZoom()}
      <Footer />
      {renderLoading()}
      {notify}
    </DashboardLayout>
  );
}

export default Product;
